module.exports = __webpack_public_path__ + "static/media/inktoberCider.3d5ec42f.gif";